import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import Doors from './appcomponents/Doors';
import MainCenterBar from './MainCenterBar';
import MainPage from './mainpage/mainpage';
import AboutProxima from './aboutproxima/AboutProxima';
import Subscription from './subscriptioncomponents/subscription';
import LinkTree from './linktree/linktree';
import UserContext from './UserContext';

function App() {
    const { userInfo } = useContext(UserContext);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginScreen />} />
                <Route
                    path="/main"
                    element={
                        userInfo.wallet_address && userInfo.jwt
                            ? <MainPage />
                            : <Navigate to="/" replace />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

// Your login logic and animation stay here, but now inside its own component!
function LoginScreen() {
    const [slideCenter, setSlideCenter] = React.useState(false);
    const [showPopup, setShowPopup] = React.useState(false);
    const [showDoors, setShowDoors] = React.useState(false);
    const [popupType, setPopupType] = React.useState(null);

    const navigate = useNavigate();

    const handleLoginSuccess = () => {
        setSlideCenter(true);
        setShowDoors(true);

        // Delay to match your animation (e.g., 1500ms)
        setTimeout(() => {
            navigate('/main');
        }, 3000);
    };

    const handleDoorsOpened = () => {
        // You can keep this for debug/extra logic
    };

    const closePopup = () => setPopupType(null);

    return (
        <div className="p-App">
            {showDoors && (
                <div className="mainpage-wrapper visible">
                    {/* You *could* preload MainPage here for smoother transition if you want */}
                </div>
            )}
            <Doors isOpen={showDoors} onOpened={handleDoorsOpened} />
            <MainCenterBar
                slideCenter={slideCenter}
                setShowPopup={setShowPopup}
                setPopupType={setPopupType}
                onLoginSuccess={handleLoginSuccess}
            />
            {popupType === 'about' && <AboutProxima onClose={closePopup} />}
            {popupType === 'subscribe' && <Subscription onClose={closePopup} />}
            {popupType === 'linktree' && <LinkTree onClose={closePopup} />}
        </div>
    );
}

export default App;
